export enum ActionTypes {
  CreateUsageStats = 'createUsageStats',
}
